import AuthService from 'services/auth'
import { useNavigate } from 'react-router-dom'
import CutileiLogo from 'icons/logo-complex-white.png'
import CutileiName from 'icons/cutilei-white-yellow.png'
import Google from 'icons/google.svg?url'
import Apple from 'icons/apple.svg?url'
import { FaBriefcase, FaStar, FaAward, FaCheck, FaWhatsapp } from 'react-icons/fa'

import {
  Container,
  Section,
  Banner,
  Header,
  Footer,
  FooterLine,
  LinkShortcut,
  InfoContainer,
  BigInfoContainer,
  InnerContainer,
  ItemGrid,
  IconCircle,
  Row,
  ItemRow,
  Column,
  Logo,
  SmallImage,
  SmallLogoImg,
  HeroImage,
  Button,
  LinkButton,
  IconLink,
  Title,
  Label,
  SubTitle,
  LinkText,
  NumberText,
  MoneyText
} from './styles'

export default function Homepage () {
  const isSigned = AuthService.isSigned ()
  const userType = AuthService.getUserType ()
  const accessBusinessArea = isSigned && ['business', 'professional'].includes (userType)
  const accessCompanyArea = isSigned && userType === 'company'
  const navigate = useNavigate ()

  const renderAppStoreButton = () => {
    return (
      <LinkButton style={{paddingLeft: 10}}>
        <div>  
          <IconLink
            href='https://apps.apple.com/az/app/cutilei/id1634300864'
            target='_blank'
            rel='noopener noreferrer'
          >
            <SmallLogoImg src={Apple} alt='App store'/>
          </IconLink>
          <IconLink
            href='https://play.google.com/store/apps/details?id=com.cutilei.app'
            target='_blank'
            rel='noopener noreferrer'
          >
            <SmallLogoImg src={Google} alt='Google Play Store'/>
          </IconLink>
        </div>
        Baixar app
      </LinkButton>
    )
  }
  
  return (
    <Container>
      <Header>
        <Row>
          <LinkShortcut href='#inicio'>
            <Row>
              <Logo src={CutileiLogo} alt='Cutilei'/>
              <Logo height={22} src={CutileiName} alt='Cutilei'/>
            </Row>
          </LinkShortcut>
          <LinkShortcut href='#quemSomos' hideOnMobile={true}>
            Benefícios
          </LinkShortcut>
          <LinkShortcut href='#planos' hideOnMobile={true}>
            Planos
          </LinkShortcut>
          <LinkShortcut
            href={accessCompanyArea ? '/company' : '/company/login'}
            hideOnMobile={true}
          >
            Cutilei para empresas
          </LinkShortcut>
        </Row>
        <Row>
          <LinkShortcut
            href='https://wa.me/message/SH5AWAQ6UP4IF1'
            target='_blank'
            rel='noopener noreferrer'
          >
            Precisa de ajuda?
          </LinkShortcut>
          <Button
            onClick={() => navigate (accessBusinessArea ? '/business' : '/login')}
            hideOnMobile={true}
          >
            Entrar
          </Button>
        </Row>
      </Header>
      <Section id='inicio'>
        <Banner>
          <Column>
            <Title>
              A revolução da beleza inteligente:<br/>
              <span>Unhas ilimitadas.</span>
            </Title>
            <SubTitle>
              O primeiro clube de assinatura que conecta você aos salões mais próximos. 
              Liberdade para fazer as mãos e os pés quando quiser, onde estiver, por um preço fixo. 
              O seu lifestyle merece esse upgrade. 
            </SubTitle>
            <Row columnOnMobile={true}>
              <Button width={200} onClick={() => navigate ('/signup')}>
                Cadastrar salão
              </Button>
              {renderAppStoreButton ()}
            </Row>
            <Row>
              <Row>
                <SmallImage src='profile1.png'/>
                <SmallImage src='profile2.png' style={{marginLeft:-20}}/>
                <SmallImage src='profile3.png' style={{marginLeft:-20}}/>
              </Row>
              <Label style={{textAlign: 'left'}}>
                Junte-se a +2000<br/> 
                <span>mulheres satisfeitas</span>
              </Label>
            </Row>
          </Column>
          <HeroImage src='camila.png' alt='Cutilei'/>
        </Banner>
      </Section>
      <Section id='quemSomos'>
        <Title>
          <span>Otimize</span> seu tempo e eleve a sua autoestima
        </Title>
        <SubTitle>
          Saia da zona de conforto. Automatize seu agendamento, garanta qualidade e economize no final do mês com nossa rede de parceiros selecionados.
        </SubTitle>
        <ItemGrid>
          <InfoContainer>
            <NumberText color='#FFC100'>100%</NumberText>
            <Title>Prático</Title>
            <SubTitle>
              Agende com apenas <span>6 cliques</span>. Apresente o QR code no salão e faça as unhas.
            </SubTitle>
          </InfoContainer>
          <InfoContainer bgColor='#FFC100'>
            <NumberText>60%</NumberText>
            <Title color='#000000'>
              de economia Mensal
            </Title>
            <SubTitle color='#000000'>
              O valor da assinatura é menor do que você gasta pagando avulso.
            </SubTitle>
          </InfoContainer>
          <InfoContainer style={{justifyContent: 'center'}}>
            <Title>Mais perto de você</Title>
            <SubTitle>
              O app te conecta aos salões <span>mais próximos</span> e aos <span>mais bem avaliados</span>.
            </SubTitle>
          </InfoContainer>
        </ItemGrid>
      </Section>
      <Section id='planos'>
        <Title>Escolha o plano que combine com o seu ritmo</Title>
        <SubTitle>Sem surpresas no cartão, cancele quando quiser.</SubTitle>
        <ItemGrid>
          <InfoContainer bgColor='#525252' style={{padding: '20px 15px 15px'}}>
            <SubTitle fontSize={24} style={{fontWeight: 600, lineHeight: '24px'}}>
              Nós valorizamos seu tempo e sua beleza
            </SubTitle>
            <InnerContainer>
              <SubTitle color='#000000'>
                Temos planos que <span>cabem no seu bolso</span>. Escolha o seu e comece a aproveitar todos os benefícios da Cutilei.
              </SubTitle>
            </InnerContainer>
          </InfoContainer>
          <InfoContainer bgColor='#F0F0F0' style={{alignItems: 'flex-start'}}>
            <MoneyText>R$ 99,90 / mês</MoneyText>
            <ItemRow fontSize={20}>
              <FaAward size={24} color='#FFC100'/>
              <SubTitle color='#000000'>Experiência completa</SubTitle>
            </ItemRow>
            <MoneyText width={125} height={30} fontSize={14}>
              <FaStar size={14}/> Mais popular
            </MoneyText>
            <SubTitle color='#000000' style={{textAlign: 'left'}}>
              O tratamento VIP que você merece, da cabeça aos pés.
            </SubTitle>
            <Column gap={5}>
              <ItemRow>
                <IconCircle>
                  <FaCheck size={14} color='#FFC100'/>
                </IconCircle>
                <SubTitle color='#000000'>Mão (cutilagem e esmaltação)</SubTitle>
              </ItemRow>
              <ItemRow>
                <IconCircle>
                  <FaCheck size={14} color='#FFC100'/>
                </IconCircle>
                <SubTitle color='#000000'>Pé (cutilagem e esmaltação)</SubTitle>
              </ItemRow>
              <ItemRow>
                <IconCircle>
                  <FaCheck size={14} color='#FFC100'/>
                </IconCircle>
                <SubTitle color='#000000'>Pé e mão (cutilagem e esmaltação)</SubTitle>
              </ItemRow>
              <ItemRow>
                <IconCircle>
                  <FaCheck size={14} color='#FFC100'/>
                </IconCircle>
                <SubTitle color='#000000'>Esmaltação de mão</SubTitle>
              </ItemRow>
            </Column>
          </InfoContainer>
          <InfoContainer style={{alignItems: 'flex-start'}}>
            <MoneyText>R$ 59,90 / mês</MoneyText>
            <ItemRow fontSize={20}>
              <FaBriefcase size={24} color='#FFFFFF'/>
              <SubTitle>Experiência básica</SubTitle>
            </ItemRow>
            <SubTitle style={{textAlign: 'left'}}>
              Para quem precisa estar sempre apresentável no dia a dia.
            </SubTitle>
            <Column gap={5}>
              <ItemRow>
                <IconCircle theme='dark'>
                  <FaCheck size={14} color='#FFC100'/>
                </IconCircle>
                <SubTitle>Mão (cutilagem e esmaltação)</SubTitle>
              </ItemRow>
              <ItemRow>
                <IconCircle theme='dark'>
                  <FaCheck size={14} color='#FFC100'/>
                </IconCircle>
                <SubTitle>Esmaltação de mão</SubTitle>
              </ItemRow>
            </Column>
          </InfoContainer>
        </ItemGrid>
      </Section>
      <Section id='apps'>
        <BigInfoContainer>
          <Title>
            Pronta para viver o <span>futuro da beleza</span>?
          </Title>
          <SubTitle>
            Começe hoje com a experiência básica ou completa.<br/>
            Conectamos você aos salões mais próximos de sua região automaticamente.
          </SubTitle>
          <Row>
            {renderAppStoreButton ()}
            <LinkButton
              href='https://wa.me/message/SH5AWAQ6UP4IF1'
              target='_blank'
              rel='noopener noreferrer'
              style={{
                background: 'linear-gradient(to right, #FFC100, #FF9800)',
                color: '#000000'
              }}
            >
              <FaWhatsapp size={20}/>
              Fale com a Cutilei
            </LinkButton>
          </Row>
        </BigInfoContainer>
      </Section>
      <FooterLine/>
      <Footer>
        <Row>
          <Logo src={CutileiLogo} alt='Cutilei'/>
          <Logo style={{height: 24}} src={CutileiName} alt='Cutilei'/> 
        </Row>
        <Column gap={5}>
          <Label>Ajuda</Label>
          <LinkText href='https://cutilei.com/terms' target='_blank'>
            Termos de uso
          </LinkText>
          <LinkText href='https://cutilei.com/privacy-policy' target='_blank'>
            Política de privacidade
          </LinkText>   
          <LinkText
            href='https://wa.me/message/SH5AWAQ6UP4IF1'
            target='_blank'
            rel='noopener noreferrer'
          > 
            Fale com a Cutilei
          </LinkText>   
        </Column>
      </Footer>
      <FooterLine/>
      <Footer>
        <p style={{marginTop: 10, marginBottom: 10, fontFamily:'Outfit', color:'#F7F7F7'}}>
          ©2026 Cutilei LTDA, Todos os direitos reservados
        </p>
      </Footer>
    </Container>
  )
}
